import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build([
	{
		path: "/admin/communications",
		component: lazy(() => import("./AdminCommunicationsPage")),
	},
]);
